 <div class="modal-header bg-dark text-white">
    <h5 class="modal-title">
        <i class="fas fa-info-circle fa-fw"></i>
        개인정보 처리 방침
    </h5>
    <button type="button" class="close text-white" (click)="clickCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <h1>
        개인정보 처리 방침
    </h1>

    <ul class="list-unstyled list-clause">
        <li>
            <p>
                주식회사 크레스트인볼브먼트는 고객님의 개인정보를 매우 중요시하며, 「개인정보보호법」을 준수하고 있습니다. 본 개인정보처리방침은 크레스트인볼브먼트에서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보 보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 회사는 WebScan-Fleet 지능형 차량관리시스템 (allgps.co.kr) 개인정보 보호 정책은 관련 법률 및 지침에 따라 변경될 수 있으며 변경된 내용은 웹사이트 공지사항을 통하여 공지할 것입니다.
            </p>
            <ol class="">
                <li>
                    수집하는 개인정보의 항목 및 수집방법
                    <ol>
                        <li>
                            파일명 : WebScan-Fleet 이용 신청서
                        </li>
                        <li>
                            수집항목
                            <ul>
                                <li>
                                    수집양식 : 고객 가입 신청서
                                </li>
                                <li>
                                    필수항목 : 성명, 연락처, 이메일, 회사명, 소재지, 회원아이디, 비밀번호, 법정대리인(성명, 연락처, 이메일, 관계, 소재지)
                                </li>
                            </ul>
                        </li>
                        <li>
                            수집방법 : 서면양식, 이메일, FAX 등에 의한 개인정보 수집동의 절차 확인 후 수집
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보의 수집 및 이용목적
                    <ol>
                        <li>
                            차량 관제 서비스 신청, 변경, 해지, 개통, A/S
                        </li>
                        <li>
                            차량 관제, 운행경로, 승용차, 오토바이, 버스 등의 운행기록 분석
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보의 보유 및 이용기간 및 파기절차 및 파기방법
                    <ol>
                        <li>
                            다음에 정한 보유기간 동안 개인정보를 보유하며 그 이후는 지체 없이 파기합니다.
                            <ul>
                                <li>
                                    보유기간 : 서비스 가입 후 해지일 까지 이용 후 6개월까지 보유합니다.
                                </li>
                                <li>
                                    파기절차 :
                                    <ul>
                                        <li>
                                            개인정보는 수집 이용 달성 후 개인정보 일정 기간동안 저장된 후 파기 됩니다.
                                        </li>
                                        <li>
                                            개인정보는 보호법에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    파기방법 : 전자적 파일은 재생할 수 없는 기술적 방법을 사용하여 삭제하고 종이자료는 분쇄기로 분쇄하거나 소각
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    이용자 및 법정대리인의 권리와 행사방법
                    <ol>
                        <li>
                            고객은 언제든지 등록되어진 자신의 개인정보 열람․정정․처리정지 요구 등의 권리를 행사할 수 있습니다.
                        </li>
                        <li>
                            이용자의 개인정보 조회 및 수정은 홈페이지의 접속자 정보에서 가능하고 가입 및 해지는 크레스트인볼브먼트 콜센터로 연락하여 본인 확인 절차를 거친 후 탈퇴가 가능합니다.
                            <ul>
                                <li>
                                    담당자 : 조상현
                                </li>
                                <li>
                                    부 서 : 크레스트인볼브먼트(주) 웹스캔 영업팀
                                </li>
                                <li>
                                    주 소 : 서울특별시 성동구 성수이로 118 (성수동2가) 성수아카데미타워 205호(성수)
                                </li>
                                <li>
                                    연락처 : 1833-5697
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보의 제3자 제공
                    <ol>
                        <li>
                            수집된 개인정보는 법령의 근거가 있는 경우 외에는 제3자에게 제공하지 않습니다. 다만 고객의 동의가 있거나 다음 사항의 경우 예외로 합니다.
                            <ul>
                                <li>
                                    서비스의 제공에 관한 계약의 이행을 위해 피료한 개인정보를 경제적 기술적인 사유로 통상의 통의를 받는 것이 현저히 곤란한 경우
                                </li>
                                <li>
                                    법령의 규졍에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보 처리의 위탁
                    <ol>
                        <li>
                            회사는 고객님의 동의없이 고객님의 개인정보 취급을 외부 업체에 위탁하지 않습니다.
                        </li>
                        <li>
                            향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보 보호책임자
                    <ol>
                        <li>
                            개인정보 보호책임자
                            <ul>
                                <li>
                                    이 름 : 진 상 국
                                </li>
                                <li>
                                    부 서 : 크레스트인볼브먼트(주) 웹스캔 영업팀
                                </li>
                                <li>
                                    전화번호 : 1833-5697
                                </li>
                                <li>
                                    팩스번호 : 02-578-0669
                                </li>
                                <li>
                                    이메일 : sangkook.chin@crestinvolvement.com
                                </li>
                            </ul>
                        </li>
                        <li>
                            개인정보 보호담당자
                            <ul>
                                <li>
                                    이 름 : 조 상 현
                                </li>
                                <li>
                                    부 서 : 크레스트인볼브먼트(주) 웹스캔 영업팀
                                </li>
                                <li>
                                    전화번호 : 1833-5697
                                </li>
                                <li>
                                    팩스번호 : 02-578-0669
                                </li>
                                <li>
                                    이메일 : sanghyun.cho@crestinvolvement.com
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    개인정보의 안전성 확보조치
                    <ol>
                        <li>
                            고객님께서 제공하신 모든 정보는 방화벽 등 보안장비에 의해 안전하게 보호되고 있습니다.
                        </li>
                        <li>
                            고객의 개인정보는 비밀번호에 의해 보호되며, 암호 알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL)를 채택하고 있습니다.
                        </li>
                        <li>
                            개인정보를 처리하는 관제팀 인원을 최소한으로 제한하고 정기적인 교육과 비밀번호 갱신을 통해 개인정보가 유출되지 않도록 안전하게 관리하고 있습니다.
                        </li>
                    </ol>
                </li>
                <li>
                    권익침해 구제방법
                    <ol>
                        <li>
                            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
                            <ul>
                                <li>
                                    개인정보분쟁조정위원회 : (국번없이) 118(내선2번)
                                </li>
                                <li>
                                    정보보호마크인증위원회 : 02-580-0533~4 (http://eprivacy.or.kr)
                                </li>
                                <li>
                                    대검찰청 사이버범죄수사단 : 02-3480-3571, cybercid@spo.go.kr (http://www.spo.go.kr/)
                                </li>
                                <li>
                                    경찰청 사이버테러대응센터 : 1566-0112 (http://www.netan.go.kr/)<br>
                                    「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정/삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br>
                                    ※ 행정심판에 대해 자세한 사항은 법제처 (http://www.moleg.go.kr) 홈페이지를 참고하시기 바랍니다.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    정책 변경에 따른 공지의무
                    <ol>
                        <li>
                            이 개인정보취급방침은 2015년 04월 1일에 개정되었으며, 법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전에 홈페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다. 단, 개인정보의 제3자 제공, 수집·이용 목적 변경, 보유기간 변경 등 중요한 사항이 변경되는 경우에는 이용자의 동의를 얻도록 하겠습니다.
                        </li>
                    </ol>
                </li>
            </ol>
        </li>
        <li>
            공고일자 : 2017년 4월 6일 / 시행일자 : 2016년 4월 21일
        </li>
    </ul>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        ngbAutofocus
        (click)="clickCancel()">
        <i class="far fa-times-circle fa-fw"></i>
        닫기
    </button>
</div>
